/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_ApplyInputs */

const en_us2_profile_editors_apply = /** @type {(inputs: Profile_Editors_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const pt_br2_profile_editors_apply = /** @type {(inputs: Profile_Editors_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const es_419_profile_editors_apply = /** @type {(inputs: Profile_Editors_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const pt_pt2_profile_editors_apply = /** @type {(inputs: Profile_Editors_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const fr_fr2_profile_editors_apply = /** @type {(inputs: Profile_Editors_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer`)
};

const de_de2_profile_editors_apply = /** @type {(inputs: Profile_Editors_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übernehmen`)
};

const it_it2_profile_editors_apply = /** @type {(inputs: Profile_Editors_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Profile_Editors_ApplyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_apply = /** @type {((inputs?: Profile_Editors_ApplyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_ApplyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_apply(inputs)
	if (locale === "es-419") return es_419_profile_editors_apply(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_apply(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_apply(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_apply(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_apply(inputs)
	return en_us2_profile_editors_apply(inputs)
});
export { profile_editors_apply as "profile-editors.apply" }